import { assignmentStatus } from "../utils/enums";

export interface ILinkedAssignmentSummary {
  id: string;
  status: string;
  applicationType: string;
  documentType: string;
}

export const GENERATE_APPLICATION_CHECKBOX_LABEL = "Odrabiam to wyjście";

export const GENERATE_APPLICATION_CHECKBOX_TOOLTIP =
  "Podczas rozliczenia powiązanego zlecenia możesz wskazać rzeczywistą datę odpracowania. Nie musi to być ten sam dzień co wyjście.";

export const GENERATE_APPLICATION_DETAILS_SUFFIX = "(z odpracowaniem)";

export const GENERATED_COMPENSATION_REALIZATION_DATE_TOOLTIP =
  "Tu wskazujesz rzeczywisty dzień odpracowania. Nie musi to być ten sam dzień co powiązane wyjście.";

export type LinkedCompensationMessageVariant = "warning" | "info" | "success";

export interface ILinkedCompensationMessage {
  text: string;
  variant: LinkedCompensationMessageVariant;
}

export function getChildCompensationMessage(
  parentStatus: string | undefined,
  childStatus: string | undefined
): ILinkedCompensationMessage | null {
  if (!parentStatus || !childStatus) {
    return null;
  }

  if (
    parentStatus === assignmentStatus.Realized &&
    childStatus === assignmentStatus.Accepted
  ) {
    return {
      text: "Wyjście zostało już rozliczone. Rozlicz to zlecenie odpracowania, aby przywrócić godziny do puli.",
      variant: "warning",
    };
  }

  if (
    parentStatus === assignmentStatus.Accepted &&
    childStatus === assignmentStatus.Accepted
  ) {
    return {
      text: "To zlecenie służy do odpracowania powiązanego wyjścia. Najpierw rozlicz wyjście, potem odpracowanie.",
      variant: "info",
    };
  }

  if (
    parentStatus === assignmentStatus.Realized &&
    childStatus === assignmentStatus.Realized
  ) {
    return {
      text: "Wyjście i odpracowanie zostały rozliczone.",
      variant: "success",
    };
  }

  if (
    parentStatus === assignmentStatus.Accepted &&
    childStatus === assignmentStatus.Realized
  ) {
    return {
      text: "Odpracowanie rozliczone, ale wniosek o wyjście jeszcze nie — rozlicz wyjście, aby domknąć proces.",
      variant: "warning",
    };
  }

  return null;
}
